import { map, compact } from 'lodash';

export default function pluckSelectedGroupIds(selectedFields, groupKey = 'group') {
  return compact(map(selectedFields, `${groupKey}.value.id`));
}
